import React from "react";
import analytics from "web/script/analytics/analytics";
import { BreadcrumbsSerializer } from "web/types/serializers";
import JSONLD from "web/react/components/json-ld/json-ld";
import styles from "./breadcrumbs.css";

interface BreadCrumbsProps extends BreadcrumbsSerializer {
    type: "feed" | "pdp";
}

function Breadcrumbs({
    breadcrumbs,
    json_ld_schema: jsonLdSchema,
    type,
}: BreadCrumbsProps): React.ReactElement {
    function handleBreadcrumbClick(): void {
        const action = type === "pdp" ? "pdp_related_click" : "feed_click";
        analytics.event(`${type}_breadcrumb`, action);
    }

    return (
        <>
            <ol className={styles.breadcrumbs}>
                {breadcrumbs.map((breadcrumb) => (
                    <li key={breadcrumb.name} className={styles.breadcrumb}>
                        {breadcrumb.url ? (
                            <a href={breadcrumb.url} onClick={handleBreadcrumbClick}>
                                <span>{breadcrumb.name}</span>
                            </a>
                        ) : (
                            <span>{breadcrumb.name}</span>
                        )}
                    </li>
                ))}
            </ol>

            {jsonLdSchema && <JSONLD JSONLD={jsonLdSchema} />}
        </>
    );
}

export default Breadcrumbs;
